import { createAsyncThunk } from '@reduxjs/toolkit'

import { dashboardApi } from 'apis'
export const DASHBOARD_SLICE_NAME = 'dashboard'

export const getDashboardInfo = createAsyncThunk(`${DASHBOARD_SLICE_NAME}/getDashboardInfo`, async () => {
  const response = await dashboardApi.getDashboardInfo()
  return response.data
})
